/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataProvider } from './DataProvider';
import {
    DataProviderFromJSON,
    DataProviderFromJSONTyped,
    DataProviderToJSON,
    DataProviderToJSONTyped,
} from './DataProvider';

/**
 * 
 * @export
 * @interface PaginatedDataProviderList
 */
export interface PaginatedDataProviderList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataProviderList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataProviderList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DataProvider>}
     * @memberof PaginatedDataProviderList
     */
    results: Array<DataProvider>;
}

/**
 * Check if a given object implements the PaginatedDataProviderList interface.
 */
export function instanceOfPaginatedDataProviderList(value: object): value is PaginatedDataProviderList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDataProviderListFromJSON(json: any): PaginatedDataProviderList {
    return PaginatedDataProviderListFromJSONTyped(json, false);
}

export function PaginatedDataProviderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDataProviderList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(DataProviderFromJSON)),
    };
}

export function PaginatedDataProviderListToJSON(json: any): PaginatedDataProviderList {
    return PaginatedDataProviderListToJSONTyped(json, false);
}

export function PaginatedDataProviderListToJSONTyped(value?: PaginatedDataProviderList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DataProviderToJSON)),
    };
}

